export const authNe: Record<string, string> = {
  "Customer account": "ग्राहक खाता",
  "Welcome back": "फेरि स्वागत छ",
  "Log in to see your partner balances and redeem rewards.":
    "आफ्नो साझेदार मौज्दात हेर्न र पुरस्कार रिडिम गर्न लग इन गर्नुहोस्।",
  "Business Owner workspace": "व्यवसाय मालिक कार्यस्थल",
  "Welcome, partner": "स्वागत छ, साझेदार",
  "Manage rewards and customer engagement for your business.":
    "आफ्नो व्यवसायका पुरस्कार र ग्राहक सहभागिता व्यवस्थापन गर्नुहोस्।",
  "Platform administration": "प्लेटफर्म प्रशासन",
  "Super admin login": "सुपर एडमिन लग इन",
  "Manage Mero Perks Business Owners and platform access.":
    "मेरो पर्क्स व्यवसाय मालिक र प्लेटफर्म पहुँच व्यवस्थापन गर्नुहोस्।",
  "Same places. More perks.": "उही ठाउँहरू। अझ धेरै पर्क्स।",
  "Shop, dine, stay, and enjoy a shared rewards network made for real life.":
    "किनमेल, भोजन र बसाइसँगै वास्तविक जीवनका लागि बनेको साझा पुरस्कार सञ्जालको आनन्द लिनुहोस्।",
  "“Mero means mine—a loyalty experience that feels personal, wherever you shop.”":
    "“मेरो भनेको आफ्नै हो—जहाँ किनमेल गरे पनि व्यक्तिगत महसुस हुने वफादारी अनुभव।”",
  "Back to rewards": "पुरस्कारमा फर्कनुहोस्",
  "Business Owner ID or slug": "व्यवसाय मालिक आईडी वा कोड",
  "Business Code": "व्यवसाय कोड",
  "e.g. sunrise-cafe": "जस्तै: sunrisecafe",
  "Provided by your Mero Perks administrator.": "तपाईंको मेरो पर्क्स प्रशासकले उपलब्ध गराएको।",
  "Email address": "इमेल ठेगाना",
  "Enter your password": "आफ्नो पासवर्ड प्रविष्ट गर्नुहोस्",
  "Signing in…": "लग इन हुँदैछ…",
  "Sign in": "लग इन गर्नुहोस्",
  "Remember email": "इमेल सम्झनुहोस्",
  "Remember business code": "व्यवसाय कोड सम्झनुहोस्",
  "Remember business email": "व्यवसाय इमेल सम्झनुहोस्",
  "Your account still needs email verification.": "तपाईंको खाता अझै इमेल प्रमाणीकरण गर्न बाँकी छ।",
  "Already registered but missing the verification email?":
    "पहिले नै दर्ता गर्नुभएको छ तर प्रमाणीकरण इमेल पाउनुभएन?",
  "Requesting…": "अनुरोध हुँदैछ…",
  "Resend verification email": "प्रमाणीकरण इमेल फेरि पठाउनुहोस्",
  "If this email has an unverified account, a fresh verification link is on its way.":
    "यो इमेलसँग अप्रमाणित खाता भएमा नयाँ प्रमाणीकरण लिङ्क पठाइएको छ।",
  "Email or password is incorrect.": "इमेल वा पासवर्ड गलत छ।",
  "Email, password, or business is incorrect.": "इमेल, पासवर्ड वा व्यवसाय गलत छ।",
  "Verify your email address before signing in. You can request a new verification email below.":
    "लग इन गर्नुअघि आफ्नो इमेल ठेगाना प्रमाणित गर्नुहोस्। तलबाट नयाँ प्रमाणीकरण इमेल अनुरोध गर्न सक्नुहुन्छ।",
  "Your email is verified and your business application is awaiting Super Admin approval.":
    "तपाईंको इमेल प्रमाणित छ र व्यवसाय आवेदन सुपर एडमिन स्वीकृतिको प्रतीक्षामा छ।",
  "This business application requires changes. Contact Mero Perks support for review details.":
    "यस व्यवसाय आवेदनमा परिवर्तन आवश्यक छ। समीक्षा विवरणका लागि मेरो पर्क्स सहयोगमा सम्पर्क गर्नुहोस्।",
  "This Business Owner account is not currently active.": "यो व्यवसाय मालिक खाता हाल सक्रिय छैन।",
  "Business access is unavailable.": "व्यवसाय पहुँच उपलब्ध छैन।",
  "New to Mero Perks?": "मेरो पर्क्समा नयाँ हुनुहुन्छ?",
  "New business?": "नयाँ व्यवसाय?",
  "Create a Business Owner account": "व्यवसाय मालिक खाता बनाउनुहोस्",
  "Create a free account": "निःशुल्क खाता बनाउनुहोस्",
  "Setting up a new installation?": "नयाँ स्थापना सेटअप गर्दै हुनुहुन्छ?",
  "The bootstrap flow works once, then permanently closes.":
    "प्रारम्भिक सेटअप प्रक्रिया एकपटक मात्र चल्छ र त्यसपछि स्थायी रूपमा बन्द हुन्छ।",
  "First-time setup": "पहिलो पटकको सेटअप",
  "Other portals": "अन्य पोर्टलहरू",
  Customer: "ग्राहक",
  "Business Owner": "व्यवसाय मालिक",

  "Secure initialization, built in.": "सुरक्षित प्रारम्भिक सेटअप, प्रणालीमै समावेश।",
  "Create the first Mero Perks platform administrator before inviting any Business Owners.":
    "व्यवसाय मालिकलाई आमन्त्रण गर्नुअघि पहिलो मेरो पर्क्स प्लेटफर्म प्रशासक बनाउनुहोस्।",
  "Back to super admin login": "सुपर एडमिन लग इनमा फर्कनुहोस्",
  "One-time initialization": "एकपटकको प्रारम्भिक सेटअप",
  "Create the first super admin": "पहिलो सुपर एडमिन बनाउनुहोस्",
  "This works only once. Enter the bootstrap secret configured securely in Cloudflare; it is sent only in the protected request header and is never stored by this page.":
    "यो एकपटक मात्र काम गर्छ। क्लाउडफ्लेयरमा सुरक्षित रूपमा राखिएको बुटस्ट्र्याप गोप्य कोड प्रविष्ट गर्नुहोस्; यो सुरक्षित अनुरोध हेडरमा मात्र पठाइन्छ र यस पृष्ठले भण्डारण गर्दैन।",
  "First name": "पहिलो नाम",
  "Last name": "थर",
  "Admin email": "एडमिन इमेल",
  "Create Business Owner password": "व्यवसाय मालिक पासवर्ड बनाउनुहोस्",
  "At least 12 characters": "कम्तीमा १२ अक्षर",
  "Bootstrap secret": "बुटस्ट्र्याप गोप्य कोड",
  "Configured in Cloudflare": "क्लाउडफ्लेयरमा कन्फिगर गरिएको",
  "Must match the SUPER_ADMIN_BOOTSTRAP_SECRET Worker secret.":
    "यो SUPER_ADMIN_BOOTSTRAP_SECRET वर्कर गोप्य कोडसँग मिल्नुपर्छ।",
  "Initializing…": "प्रारम्भ हुँदैछ…",
  "Create super admin": "सुपर एडमिन बनाउनुहोस्",

  "Please accept the terms to create your account.": "खाता बनाउन कृपया सर्तहरू स्वीकार गर्नुहोस्।",
  "A fresh verification link has been requested. Check your inbox.":
    "नयाँ प्रमाणीकरण लिङ्क अनुरोध गरिएको छ। आफ्नो इनबक्स जाँच्नुहोस्।",
  "One email. Every way to earn.": "एउटै इमेल। कमाउने हरेक तरिका।",
  "Your verified Mero Perks identity can hold customer and business access securely.":
    "तपाईंको प्रमाणित मेरो पर्क्स पहिचानले ग्राहक र व्यवसाय पहुँच सुरक्षित रूपमा राख्न सक्छ।",
  "ACCOUNT READY": "खाता तयार",
  "VERIFY YOUR EMAIL": "आफ्नो इमेल प्रमाणित गर्नुहोस्",
  "Your customer account is ready": "तपाईंको ग्राहक खाता तयार छ",
  "Check your inbox": "आफ्नो इनबक्स जाँच्नुहोस्",
  "was already verified. Sign in with your existing Mero Perks password.":
    "पहिले नै प्रमाणित छ। आफ्नो विद्यमान मेरो पर्क्स पासवर्डले लग इन गर्नुहोस्।",
  "We sent a secure activation link to": "हामीले सुरक्षित सक्रियता लिङ्क पठाएका छौँ:",
  "It expires in 24 hours.": "यसको म्याद २४ घण्टामा सकिन्छ।",
  "Your account was created, but the email provider could not accept the message yet. Use the resend button after the Resend key and sending domain are configured.":
    "तपाईंको खाता बन्यो, तर इमेल प्रदायकले सन्देश स्वीकार गर्न सकेन। रिसेन्ड कुञ्जी र पठाउने डोमेन कन्फिगर भएपछि फेरि पठाउने बटन प्रयोग गर्नुहोस्।",
  "Continue to customer login": "ग्राहक लग इनमा जानुहोस्",
  "Rewards make life sweeter.": "पुरस्कारले जीवन अझ मिठो बनाउँछ।",
  "Join once, discover offers from every participating business, and keep your rewards in one place.":
    "एकपटक जोडिनुहोस्, सबै सहभागी व्यवसायका अफर खोज्नुहोस् र आफ्ना पुरस्कार एकै ठाउँमा राख्नुहोस्।",
  "Free customer account": "निःशुल्क ग्राहक खाता",
  "Start earning more from every visit": "हरेक भ्रमणबाट अझ धेरै कमाउन सुरु गर्नुहोस्",
  "It takes less than a minute. No card or fee required.":
    "यसका लागि एक मिनेटभन्दा कम समय लाग्छ। कार्ड वा शुल्क आवश्यक छैन।",
  "Create password": "पासवर्ड बनाउनुहोस्",
  Birthday: "जन्ममिति",
  "(optional)": "(वैकल्पिक)",
  "Used to determine birthday reward eligibility. It is never shared publicly.":
    "जन्मदिन पुरस्कार योग्यता निर्धारण गर्न प्रयोग हुन्छ। यो सार्वजनिक रूपमा कहिल्यै साझा गरिँदैन।",
  "I agree to the Mero Perks terms and acknowledge the privacy policy.":
    "म मेरो पर्क्सका सर्तहरू स्वीकार गर्छु र गोपनीयता नीतिलाई मान्यता दिन्छु।",
  "Email me optional offers and perks. I can change this at any time.":
    "मलाई वैकल्पिक अफर र पर्क्स इमेल गर्नुहोस्। म यसलाई जुनसुकै बेला परिवर्तन गर्न सक्छु।",
  "Creating account…": "खाता बनाउँदैछ…",
  "Create my account": "मेरो खाता बनाउनुहोस्",
  "Already have an account?": "पहिले नै खाता छ?",

  "CHOOSE YOUR PLAN": "आफ्नो योजना छान्नुहोस्",
  "Start free. Grow when loyalty grows.": "निःशुल्क सुरु गर्नुहोस्। वफादारीसँगै बढ्नुहोस्।",
  "No setup fee. Pro and Master trials begin only after your business is approved.":
    "सेटअप शुल्क छैन। व्यवसाय स्वीकृत भएपछि मात्र प्रो र मास्टर परीक्षण सुरु हुन्छ।",
  "Billing cycle": "बिलिङ अवधि",
  Annual: "वार्षिक",
  Monthly: "मासिक",
  POPULAR: "लोकप्रिय",
  FREE: "निःशुल्क",
  year: "वर्ष",
  month: "महिना",
  "7-day free trial": "७ दिनको निःशुल्क परीक्षण",
  Selected: "छानिएको",
  "Choose plan": "योजना छान्नुहोस्",
  "Paid plan selection records your preferred billing cycle. No payment is collected during application review.":
    "सशुल्क योजना छनोटले तपाईंको रोजाइको बिलिङ अवधि सुरक्षित गर्छ। आवेदन समीक्षाका बेला कुनै भुक्तानी लिइँदैन।",

  "Enter the complete 9-digit PAN number.": "पूरा ९ अङ्कको प्यान नम्बर प्रविष्ट गर्नुहोस्।",
  "Checking PAN availability…": "प्यान उपलब्धता जाँच हुँदैछ…",
  "PAN verified as available.": "प्यान उपलब्ध भएको प्रमाणित भयो।",
  "This PAN number is already registered. Sign in to the existing Business Owner account or contact Mero Perks support.":
    "यो प्यान नम्बर पहिले नै दर्ता छ। विद्यमान व्यवसाय मालिक खातामा लग इन गर्नुहोस् वा मेरो पर्क्स सहयोगमा सम्पर्क गर्नुहोस्।",
  "We could not verify this PAN number. Check your connection and try again.":
    "यो प्यान नम्बर प्रमाणित गर्न सकिएन। आफ्नो इन्टरनेट जाँचेर फेरि प्रयास गर्नुहोस्।",
  "Accept the Mero Perks partner terms before submitting your application.":
    "आवेदन पेश गर्नुअघि मेरो पर्क्स साझेदार सर्तहरू स्वीकार गर्नुहोस्।",
  "Please resolve the Business PAN validation before submitting your application.":
    "आवेदन पेश गर्नुअघि व्यवसाय प्यान प्रमाणीकरण समस्या समाधान गर्नुहोस्।",
  "A fresh business-account verification email is on its way.":
    "नयाँ व्यवसाय खाता प्रमाणीकरण इमेल पठाइएको छ।",
  "Your partnership starts here.": "तपाईंको साझेदारी यहाँबाट सुरु हुन्छ।",
  "Every Mero Perks business is email-verified and reviewed before receiving platform access.":
    "हरेक मेरो पर्क्स व्यवसायलाई प्लेटफर्म पहुँच दिनुअघि इमेल प्रमाणीकरण र समीक्षा गरिन्छ।",
  "BUSINESS APPLICATION RECEIVED": "व्यवसाय आवेदन प्राप्त भयो",
  "Ready for platform review": "प्लेटफर्म समीक्षाका लागि तयार",
  "Verify your business email": "आफ्नो व्यवसाय इमेल प्रमाणित गर्नुहोस्",
  "is in the Super Admin approval queue. We will activate Business Owner access only after review.":
    "सुपर एडमिन स्वीकृति पङ्क्तिमा छ। समीक्षापछि मात्र व्यवसाय मालिक पहुँच सक्रिय हुनेछ।",
  "We sent a secure verification link to": "हामीले सुरक्षित प्रमाणीकरण लिङ्क पठाएका छौँ:",
  "Verification moves your application into the Super Admin review queue.":
    "प्रमाणीकरणपछि तपाईंको आवेदन सुपर एडमिन समीक्षा पङ्क्तिमा जान्छ।",
  "Free—no payment required": "निःशुल्क—भुक्तानी आवश्यक छैन",
  "7-day trial after approval": "स्वीकृतिपछि ७ दिनको निःशुल्क परीक्षण",
  "Annual billing": "वार्षिक बिलिङ",
  "Monthly billing": "मासिक बिलिङ",
  "Business approval progress": "व्यवसाय स्वीकृति प्रगति",
  "Application submitted": "आवेदन पेश भयो",
  "Email verified": "इमेल प्रमाणित",
  "Super Admin approval": "सुपर एडमिन स्वीकृति",
  "Your application is saved, but the verification message could not be delivered yet. Use the resend option below.":
    "तपाईंको आवेदन सुरक्षित छ, तर प्रमाणीकरण सन्देश अझै पठाउन सकिएन। तलको फेरि पठाउने विकल्प प्रयोग गर्नुहोस्।",
  "Go to Business Owner login": "व्यवसाय मालिक लग इनमा जानुहोस्",
  "Return to Mero Perks for business": "व्यवसायका लागि मेरो पर्क्समा फर्कनुहोस्",
  "Turn loyal visits into lasting growth.": "वफादार भ्रमणलाई दीर्घकालीन वृद्धिमा बदल्नुहोस्।",
  "Submit your business details, verify the owner email, and join Mero Perks after platform review.":
    "व्यवसाय विवरण पेश गर्नुहोस्, मालिकको इमेल प्रमाणित गर्नुहोस् र प्लेटफर्म समीक्षापछि मेरो पर्क्समा जोडिनुहोस्।",
  "Build loyalty that feels local.": "स्थानीय अपनत्व महसुस हुने वफादारी बनाउनुहोस्।",
  "Choose your plan, add your business, and create a secure owner account in four clear steps.":
    "चार स्पष्ट चरणमा योजना छान्नुहोस्, व्यवसाय थप्नुहोस् र सुरक्षित मालिक खाता बनाउनुहोस्।",
  "Back to Mero Perks for business": "व्यवसायका लागि मेरो पर्क्समा फर्कनुहोस्",
  "BECOME A MERO PERKS PARTNER": "मेरो पर्क्स साझेदार बन्नुहोस्",
  "Apply for a Business Owner account": "व्यवसाय मालिक खाताका लागि आवेदन दिनुहोस्",
  "Business Owner access remains inactive until the owner email is verified and a Super Admin approves the application.":
    "मालिकको इमेल प्रमाणित र सुपर एडमिनबाट आवेदन स्वीकृत नभएसम्म व्यवसाय मालिक पहुँच निष्क्रिय रहन्छ।",
  "Complete each step in order. Your account remains inactive until the owner email is verified and a Super Admin approves the application.":
    "हरेक चरण क्रमसँग पूरा गर्नुहोस्। मालिकको इमेल प्रमाणित र सुपर एडमिनबाट आवेदन स्वीकृत नभएसम्म तपाईंको खाता निष्क्रिय रहन्छ।",
  "Business application steps": "व्यवसाय आवेदनका चरणहरू",
  "Subscription plans": "सदस्यता योजनाहरू",
  "Choose your plan": "आफ्नो योजना छान्नुहोस्",
  "Select the plan and billing cycle that fit your business.":
    "आफ्नो व्यवसायलाई सुहाउने योजना र बिलिङ अवधि छान्नुहोस्।",
  "Business identity": "व्यवसाय पहिचान",
  "Tell us how your business is registered and known to customers.":
    "आफ्नो व्यवसाय कसरी दर्ता छ र ग्राहकले कुन नामले चिन्छन् भन्ने जानकारी दिनुहोस्।",
  "Trading name": "व्यापारिक नाम",
  "Legal business name": "कानुनी व्यवसाय नाम",
  "Business PAN number": "व्यवसाय प्यान नम्बर",
  "Enter the 9-digit PAN registered to this business.":
    "यस व्यवसायमा दर्ता भएको ९ अङ्कको प्यान प्रविष्ट गर्नुहोस्।",
  "Business type": "व्यवसाय प्रकार",
  Retail: "खुद्रा",
  "Food & beverage": "खाना तथा पेय",
  Hospitality: "आतिथ्य",
  Entertainment: "मनोरञ्जन",
  Travel: "यात्रा",
  Other: "अन्य",
  "Business code": "व्यवसाय कोड",
  "Use letters and numbers only. This is used when your team signs in.":
    "अक्षर र अङ्क मात्र प्रयोग गर्नुहोस्। तपाईंको टोलीले लग इन गर्दा यो प्रयोग हुन्छ।",
  Website: "वेबसाइट",
  "Business contact & location": "व्यवसाय सम्पर्क र स्थान",
  "Add the contact and operating details customers can rely on.":
    "ग्राहकले भरोसा गर्न सक्ने सम्पर्क र सञ्चालन विवरण थप्नुहोस्।",
  "Business email": "व्यवसाय इमेल",
  "Business phone": "व्यवसाय फोन",
  "Street address": "सडक ठेगाना",
  City: "सहर",
  Province: "प्रदेश",
  "Postal code": "हुलाक कोड",
  Country: "देश",
  Currency: "मुद्रा",
  Timezone: "समय क्षेत्र",
  "MAP LOCATION": "नक्सा स्थान",
  "Pin your business entrance": "आफ्नो व्यवसायको प्रवेशद्वार पिन गर्नुहोस्",
  "Help customers find the exact entrance. Your written address stays unchanged.":
    "ग्राहकलाई ठ्याक्कै प्रवेशद्वार फेला पार्न मद्दत गर्नुहोस्। तपाईंले लेखेको ठेगाना परिवर्तन हुँदैन।",
  "Use current location": "हालको स्थान प्रयोग गर्नुहोस्",
  "Place pin at map center": "नक्साको बीचमा पिन राख्नुहोस्",
  "Finding your location…": "तपाईंको स्थान खोजिँदैछ…",
  "Clear pin": "पिन हटाउनुहोस्",
  "Select a point on the map": "नक्सामा स्थान छान्नुहोस्",
  "Click or tap the map to place your business pin.":
    "व्यवसायको पिन राख्न नक्सामा क्लिक वा ट्याप गर्नुहोस्।",
  "Requesting your current location…": "तपाईंको हालको स्थान अनुरोध गरिँदैछ…",
  "Pin selected. It will be saved with your application.":
    "पिन चयन भयो। यो तपाईंको आवेदनसँग सुरक्षित हुनेछ।",
  "Pin moved. It will be saved with your application.":
    "पिन सारियो। यो तपाईंको आवेदनसँग सुरक्षित हुनेछ।",
  "Current location found. Move the pin to the exact business entrance if needed.":
    "हालको स्थान भेटियो। आवश्यक भए पिनलाई व्यवसायको ठ्याक्कै प्रवेशद्वारमा सार्नुहोस्।",
  "Location access is unavailable in this browser. Place the pin manually.":
    "यो ब्राउजरमा स्थान पहुँच उपलब्ध छैन। पिन हातैले राख्नुहोस्।",
  "We could not access your current location. Check browser permissions or place the pin manually.":
    "हामीले तपाईंको हालको स्थान प्राप्त गर्न सकेनौँ। ब्राउजर अनुमति जाँच्नुहोस् वा पिन हातैले राख्नुहोस्।",
  "Pin cleared. Click or tap the map to choose another location.":
    "पिन हटाइयो। अर्को स्थान छान्न नक्सामा क्लिक वा ट्याप गर्नुहोस्।",
  "Pin selected at the map center. Move the map and place it again if needed.":
    "नक्साको बीचमा पिन चयन भयो। आवश्यक भए नक्सा सारेर फेरि पिन राख्नुहोस्।",
  Latitude: "अक्षांश",
  Longitude: "देशान्तर",
  "Selected coordinates": "चयन गरिएका निर्देशाङ्क",
  "Map for pinning the business location": "व्यवसायको स्थान पिन गर्ने नक्सा",
  "Selected business location": "चयन गरिएको व्यवसाय स्थान",
  "Owner login & verification": "मालिक लग इन र प्रमाणीकरण",
  "Secure the owner account and confirm the application.":
    "मालिक खाता सुरक्षित गर्नुहोस् र आवेदन पुष्टि गर्नुहोस्।",
  "Owner first name": "मालिकको पहिलो नाम",
  "Owner last name": "मालिकको थर",
  "Owner email": "मालिकको इमेल",
  "This address receives the verification link and becomes the Business Owner login.":
    "यस ठेगानामा प्रमाणीकरण लिङ्क आउँछ र यही व्यवसाय मालिक लग इन बन्छ।",
  "Create a password for this Business Owner account. The same email may also have a Customer account with a different password.":
    "यस व्यवसाय मालिक खाताका लागि पासवर्ड बनाउनुहोस्। यही इमेलमा फरक पासवर्डसहित ग्राहक खाता पनि हुन सक्छ।",
  "I confirm these business and PAN details are accurate and accept the Mero Perks partner terms.":
    "यी व्यवसाय र प्यान विवरण सही छन् भनी पुष्टि गर्दै मेरो पर्क्स साझेदार सर्तहरू स्वीकार गर्छु।",
  "Submitting application…": "आवेदन पेश हुँदैछ…",
  "Submit partner application": "साझेदार आवेदन पेश गर्नुहोस्",
  "Please resolve the Business PAN validation before continuing.":
    "अगाडि बढ्नुअघि व्यवसाय प्यान प्रमाणीकरण समस्या समाधान गर्नुहोस्।",
  Step: "चरण",
  of: "मध्ये",
  "Step 1 of 4": "४ मध्ये चरण १",
  "Step 2 of 4": "४ मध्ये चरण २",
  "Step 3 of 4": "४ मध्ये चरण ३",
  "Step 4 of 4": "४ मध्ये चरण ४",
  Back: "पछाडि",
  Continue: "अगाडि बढ्नुहोस्",
  "Already approved?": "पहिले नै स्वीकृत हुनुहुन्छ?",

  "Confirming your secure verification link…": "तपाईंको सुरक्षित प्रमाणीकरण लिङ्क पुष्टि हुँदैछ…",
  "This verification link is missing its secure token. Request a new email and try again.":
    "यस प्रमाणीकरण लिङ्कमा सुरक्षित टोकन छैन। नयाँ इमेल अनुरोध गरी फेरि प्रयास गर्नुहोस्।",
  "This verification link is invalid or has expired. Request a new email and try again.":
    "यो प्रमाणीकरण लिङ्क अमान्य छ वा म्याद सकिएको छ। नयाँ इमेल अनुरोध गरी फेरि प्रयास गर्नुहोस्।",
  "Your email is verified. You can now sign in to your Mero Perks account.":
    "तपाईंको इमेल प्रमाणित भयो। अब आफ्नो मेरो पर्क्स खातामा लग इन गर्न सक्नुहुन्छ।",
  "Verified once. Rewarded everywhere.": "एकपटक प्रमाणित। जताततै पुरस्कृत।",
  "A single secure identity connects your customer and business access without mixing their data.":
    "एउटै सुरक्षित पहिचानले डेटा नमिसाई ग्राहक र व्यवसाय पहुँच जोड्छ।",
  "EMAIL VERIFICATION": "इमेल प्रमाणीकरण",
  "Verifying your email": "तपाईंको इमेल प्रमाणित हुँदैछ",
  "You’re verified": "तपाईं प्रमाणित हुनुभयो",
  "That link didn’t work": "त्यो लिङ्कले काम गरेन",
  "Customer login": "ग्राहक लग इन",
  "Return to login": "लग इनमा फर्कनुहोस्",

  "This reset link is missing its secure token. Ask an administrator for a new link.":
    "यस रिसेट लिङ्कमा सुरक्षित टोकन छैन। नयाँ लिङ्कका लागि प्रशासकलाई अनुरोध गर्नुहोस्।",
  "This password reset link is invalid or has expired. Ask an administrator for a new link.":
    "यो पासवर्ड रिसेट लिङ्क अमान्य छ वा म्याद सकिएको छ। नयाँ लिङ्कका लागि प्रशासकलाई अनुरोध गर्नुहोस्।",
  "The passwords do not match.": "पासवर्डहरू मिलेनन्।",
  "Secure access. Fresh start.": "सुरक्षित पहुँच। नयाँ सुरुवात।",
  "Choose a strong new password for your Mero Perks customer, business, or administration access.":
    "आफ्नो मेरो पर्क्स ग्राहक, व्यवसाय वा प्रशासन पहुँचका लागि बलियो नयाँ पासवर्ड छान्नुहोस्।",
  "PASSWORD RESET": "पासवर्ड रिसेट",
  "Password updated": "पासवर्ड अद्यावधिक भयो",
  "Choose a new password": "नयाँ पासवर्ड छान्नुहोस्",
  "Your password is ready. All previous sessions were securely signed out.":
    "तपाईंको पासवर्ड तयार छ। अघिल्ला सबै सत्र सुरक्षित रूपमा लग आउट गरिएका छन्।",
  "New password": "नयाँ पासवर्ड",
  "Use at least 12 characters.": "कम्तीमा १२ अक्षर प्रयोग गर्नुहोस्।",
  "Confirm new password": "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
  "Updating…": "अद्यावधिक हुँदैछ…",
  "Update password": "पासवर्ड अद्यावधिक गर्नुहोस्",
};
